import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";

const benefits = [
{
  id: "marcas",
  label: "Para Marcas",
  headline: "Llegamos directo al lugar donde viven tus clientes.",
  subline: "Publicidad de alto impacto en entornos residenciales premium.",
  accentColor: "#00E0FF",
  items: [
  "Publicidad de alto impacto en edificios residenciales",
  "Exposición directa a audiencias urbanas de primer nivel",
  "Ubicaciones residenciales premium en toda Chile",
  "Red de gran escala con cobertura nacional",
  "Métricas reales de alcance e impacto",
  "Formatos exteriores e interiores disponibles"],

  cta: "Publicitar Ahora",
  ctaHref: "#contacto"
},
{
  id: "comunidades",
  label: "Para Comunidades",
  headline: "Monetizamos tu edificio sin costo fijo.",
  subline: "Nueva fuente de ingresos para tu comunidad, sin inversión.",
  accentColor: "#D4AF37",
  items: [
  "Nueva fuente de ingresos para la comunidad",
  "Sin costo fijo ni inversión para el edificio",
  "Instalación y gestión completamente profesional",
  "Publicidad segura y regulada en todo momento",
  "Proceso simple y sin burocracia",
  "Operador de confianza con +30 años en el rubro"],

  cta: "Monetizar mi Edificio",
  ctaHref: "#contacto"
},
{
  id: "administradores",
  label: "Para Administradores",
  headline: "Nuevo ingreso para las comunidades + comisi\xF3n.",
  subline: "Beneficia a tus comunidades y obtén comisión por cada referido.",
  accentColor: "#ffffff",
  items: [
  "Ingresos adicionales para los edificios que gestionas",
  "Comisión por cada edificio referido a la red",
  "Gestión simple y administración eficiente",
  "Operador profesional de confianza",
  "Sin responsabilidades adicionales para el admin",
  "Reporting claro y transparente"],

  cta: "Ser Administrador Partner",
  ctaHref: "#contacto"
}];


const BenefitCard = ({ benefit, index }) =>
<motion.div
  initial={{ opacity: 0, y: 40 }}
  whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.2 }}
  transition={{ duration: 0.7, delay: index * 0.12, ease: [0.16, 1, 0.3, 1] }}
  data-testid={`benefit-${benefit.id}`}
  className="flex flex-col relative"
  style={{
    padding: "48px 40px",
    backgroundColor: "#0F0F10",
    border: "1px solid rgba(255,255,255,0.05)"
  }}>

    {/* Top accent line */}
    <div
    style={{ height: "2px", backgroundColor: benefit.accentColor, marginBottom: "40px", width: "40px" }} />


    {/* Label */}
    <span
    className="font-body font-bold uppercase"
    style={{
      fontSize: "10px",
      letterSpacing: "0.28em",
      color: benefit.accentColor,
      marginBottom: "20px"
    }}>

      {benefit.label}
    </span>

    {/* Headline */}
    <h3
    className="font-heading font-bold uppercase text-white"
    style={{ fontSize: "clamp(22px, 2.5vw, 32px)", lineHeight: 1.1, marginBottom: "16px" }}>

      {benefit.headline}
    </h3>

    {/* Subline */}
    <p
    className="font-body text-zinc-500"
    style={{ fontSize: "14px", lineHeight: 1.7, fontWeight: 300, marginBottom: "36px" }}>

      {benefit.subline}
    </p>

    {/* Items */}
    <ul className="flex flex-col gap-3 flex-1 mb-10">
      {benefit.items.map((item, i) =>
    <li key={i} className="flex items-start gap-3">
          <CheckCircle2
        size={15}
        style={{ color: benefit.accentColor, flexShrink: 0, marginTop: "2px" }} />

          <span
        className="font-body text-zinc-400"
        style={{ fontSize: "13px", lineHeight: 1.6, fontWeight: 300 }}>

            {item}
          </span>
        </li>
    )}
    </ul>

    {/* CTA */}
    <a
    href={benefit.ctaHref}
    data-testid={`benefit-cta-${benefit.id}`}
    className="inline-block text-center font-body font-bold uppercase text-xs"
    style={{
      border: `1px solid ${benefit.accentColor}44`,
      color: benefit.accentColor,
      padding: "14px 28px",
      letterSpacing: "0.15em",
      transition: "background-color 0.3s, border-color 0.3s"
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.backgroundColor = `${benefit.accentColor}15`;
      e.currentTarget.style.borderColor = benefit.accentColor;
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.backgroundColor = "transparent";
      e.currentTarget.style.borderColor = `${benefit.accentColor}44`;
    }}>

      {benefit.cta}
    </a>
  </motion.div>;


const Beneficios = () =>
<section
  id="beneficios"
  data-testid="beneficios-section"
  style={{ backgroundColor: "#050505", paddingTop: "120px", paddingBottom: "120px" }}>

    <div className="edi-container">
      {/* Header */}
      <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.7 }}
      className="mb-16">

        <span className="section-label">Por qué EDIMEDIA</span>
        <div style={{ marginTop: "20px" }}>
          <div className="line-accent" />
        </div>
        <h2
        className="section-heading"
        style={{ fontSize: "clamp(42px, 5.5vw, 80px)" }}>

          Beneficios para <span style={{ color: "#00E0FF" }}>Todos</span>
        </h2>
      </motion.div>

      {/* Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        {benefits.map((benefit, i) =>
      <BenefitCard key={benefit.id} benefit={benefit} index={i} />
      )}
      </div>
    </div>
  </section>;


export { Beneficios };